import * as React from "react";
import { WidgetFrame, FormJSON } from "../studio/index.js";
export { FormSample };
/**
 * Пример формы.
 * @returns {JSX.Element} Элемент JSX.
 */
function FormSample() {
  const schema =
  {
    title: "Пример формы", // Заголовок секции.
    icon: "grid", // Иконка секции.
    properties: // Поля формы.
    {
      user_name: // Идентификатор поля.
      {
        title: "Имя пользователя", // Надпись.
        type: "string", // Тип поля.
        default: "user123" // Начальное значение
      },
      age: // Идентификатор поля.
      {
        title: "Возраст", // Надпись.
        type: "integer", // Тип поля.
        minimum: 18, // Минимальное значение
        maximum: 180, // Максимальное значение
        default: 18 // Начальное значение
      },
      weight: // Идентификатор поля.
      {
        title: "Вес", // Надпись.
        type: "number", // Тип поля.
        minimum: 20, // Минимальное значение
        maximum: 200, // Максимальное значение
        multipleOf: .1, // Шаг изменения значения
        default: 77.7 // Начальное значение
      },
      selected:
      {
        title: "Опции", // Надпись.
        type: "integer",
        enum: [1, 2, 3], // Допустимые значения.
        enumTitle: // Надписи для вариантов
          ["Вариант 1", "Вариант 2", "Вариант 3"],
      },
      remember: // Идентификатор поля.
      {
        title: "Запомнить меня", // Надпись.
        type: "boolean", // Тип поля.
      }
    },
    required: ["user_name"], // Обязательные поля.
    actions: // Кнопки действий.
      [
        {
          type: "primary", // Основное действие, см. Button.
          name: "Отправить", // Надпись на кнопке.
          icon: "sent", // Имя иконки, см. Icon.
          onClick: // Обработчик нажатия (DataHandler)
            data => alert(JSON.stringify(data))
          // Для основной кнопки можно не указывать.
          // Если не указано, будет выполнено onSubmit.
        }
      ],
    onSubmit: // Обработчик отправки данных (DataHandler)
      data => alert(JSON.stringify(data))
  };
  return (
    <WidgetFrame icon="grid" title={FormSample.title}>
      <FormJSON schema={schema} />
    </WidgetFrame>
  );
}

/**
 * Название примера для SampleRouter.
 * @private
 */
FormSample.title = "Форма";
